import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { menu, footerLinks, socialItems } from './data';
import FooterSocial from './FooterSocial';
import FooterLinks from './FooterLinks';
import FooterIcons from './FooterIcons';
import styled, { ThemeProvider } from 'styled-components';
import { Box, Link, LanguageSwitcher, useWindowSize } from '@miro-site/core';
import _theme from './theme';
import { AccordionMenu } from '@miro-site/ui-page-sections/header';
import { usePageTranslations } from '@miro-site/localization';
import { useLocalization } from '@miro-site/localization';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FooterComponent = styled(Box).attrs({
  as: 'footer',
  $styles: {
    background: _theme.footer.background,
    fontFamily: 'var(--wcds-font-secondary)',
    fontFeatureSettings: "'ss03'"
  }
}).withConfig({
  displayName: "Footer__FooterComponent",
  componentId: "sc-fzs1hi-0"
})(["*,*:before,*:after{box-sizing:border-box;}"]);
var FooterContainer = styled(Box).attrs({
  $styles: {
    maxWidth: _theme.footer.container.width,
    margin: _theme.footer.container.margin,
    paddingTop: _theme.footer.container.padding.top,
    paddingLeft: _theme.footer.container.padding.left,
    paddingRight: _theme.footer.container.padding.right,
    paddingBottom: _theme.footer.container.padding.bottom
  }
}).withConfig({
  displayName: "Footer__FooterContainer",
  componentId: "sc-fzs1hi-1"
})([""]);
var FooterList = styled(Box).attrs({
  as: 'ul',
  $styles: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginLeft: _theme.footer.list.margin,
    marginRight: _theme.footer.list.margin,
    paddingRight: _theme.footer.list.padding.right
  }
}).withConfig({
  displayName: "Footer__FooterList",
  componentId: "sc-fzs1hi-2"
})([""]);
var FooterListItem = styled(Box).attrs({
  as: 'li',
  $styles: {
    flex: '0 0 20%',
    paddingLeft: _theme.footer.item.padding,
    paddingRight: _theme.footer.item.padding
  }
}).withConfig({
  displayName: "Footer__FooterListItem",
  componentId: "sc-fzs1hi-3"
})([""]);
var FooterListTitleWrapper = styled(Box).attrs({
  $styles: {
    marginBottom: _theme.footer.categoryWrapper.margin.bottom
  }
}).withConfig({
  displayName: "Footer__FooterListTitleWrapper",
  componentId: "sc-fzs1hi-4"
})([""]);
var FooterListTitle = styled(Box).attrs({
  as: 'h3',
  $styles: {
    fontSize: _theme.footer.categoryTitle.fontSize,
    lineHeight: _theme.footer.categoryTitle.lineHeight,
    fontWeight: _theme.footer.categoryTitle.fontWeight
  }
}).withConfig({
  displayName: "Footer__FooterListTitle",
  componentId: "sc-fzs1hi-5"
})(["color:var(--wcds-footer-font-color);"]);
var FooterInnerWrapper = styled(Box).attrs(function (_ref) {
  var $isActive = _ref.$isActive;
  return {
    $styles: {
      overflow: ['hidden', null]
    }
  };
}).withConfig({
  displayName: "Footer__FooterInnerWrapper",
  componentId: "sc-fzs1hi-6"
})([""]);
var FooterInnerItem = styled(Box).attrs({
  as: 'li',
  $mt: _theme.footer.innerItem.margin.top
}).withConfig({
  displayName: "Footer__FooterInnerItem",
  componentId: "sc-fzs1hi-7"
})(["&:first-child{margin-top:0;}"]);
var FooterInnerLink = styled(Link).withConfig({
  displayName: "Footer__FooterInnerLink",
  componentId: "sc-fzs1hi-8"
})(["", ""], function (props) {
  return props.theme.normalizeStyles(_theme.footer.links.menu);
});
var FooterAdditionalLink = styled(Link).attrs({}).withConfig({
  displayName: "Footer__FooterAdditionalLink",
  componentId: "sc-fzs1hi-9"
})(["color:var(--wcds-footer-font-color);", ""], function (props) {
  return props.theme.normalizeStyles(_theme.footer.links.additional);
});
var FooterBottomContainer = styled(Box).attrs({
  $styles: {
    borderTop: '1px solid var(--deprecated-legacy-dimmed-gray)',
    color: 'var(--wcds-footer-font-color)'
  },
  $mt: _theme.footer.bottomContainer.margin.top,
  $pt: _theme.footer.bottomContainer.padding.top
}).withConfig({
  displayName: "Footer__FooterBottomContainer",
  componentId: "sc-fzs1hi-10"
})([""]);
var FooterRow = styled(Box).attrs({
  as: 'div',
  $styles: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    textAlign: ['center', 'center']
  }
}).withConfig({
  displayName: "Footer__FooterRow",
  componentId: "sc-fzs1hi-11"
})([""]);
var FooterCol = styled(Box).attrs({
  $styles: {
    display: 'flex',
    flex: ['0 0 100%', '0 0 100%', '0 0 auto', '0 0 auto', '0 0 auto']
  }
}).withConfig({
  displayName: "Footer__FooterCol",
  componentId: "sc-fzs1hi-12"
})(["&:nth-of-type(1){", "}&:nth-of-type(2){", "}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.normalizeStyles({
    order: [2, 2, 1, 1]
  });
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.normalizeStyles({
    order: [1, 1, 2, 2]
  });
});
var FooterInnerRow = styled(Box).attrs({
  $styles: {
    display: 'flex',
    justifyContent: ['center', 'center', '', '', ''],
    alignItems: 'center',
    flexWrap: 'wrap'
  }
}).withConfig({
  displayName: "Footer__FooterInnerRow",
  componentId: "sc-fzs1hi-13"
})([""]);
var FooterInnerCol = styled(Box).attrs({
  $styles: {
    flex: ['0 0 100%', '0 0 100%', '0 0 auto']
  },
  $mr: _theme.footer.innerColumn.margin.right
}).withConfig({
  displayName: "Footer__FooterInnerCol",
  componentId: "sc-fzs1hi-14"
})(["&:last-child{margin-right:0;}"]);
var FooterInnerColWrapper = styled(Box).attrs({
  $styles: {
    display: 'flex',
    flexWrap: ['wrap', 'wrap', undefined],
    justifyContent: ['center', 'center', undefined]
  }
}).withConfig({
  displayName: "Footer__FooterInnerColWrapper",
  componentId: "sc-fzs1hi-15"
})([""]);
var LanguageSwitcherContainer = styled(Box).attrs({
  $mr: [null, null, 20, 24]
}).withConfig({
  displayName: "Footer__LanguageSwitcherContainer",
  componentId: "sc-fzs1hi-16"
})([""]);

var Footer = function Footer(props) {
  var label = props.label,
      _props$categories = props.categories,
      categories = _props$categories === void 0 ? menu : _props$categories,
      _props$socialMedia = props.socialMedia,
      socialMedia = _props$socialMedia === void 0 ? socialItems : _props$socialMedia,
      _props$bottomLinks = props.bottomLinks,
      bottomLinks = _props$bottomLinks === void 0 ? footerLinks : _props$bottomLinks;

  var _usePageTranslations = usePageTranslations(),
      _usePageTranslations2 = _slicedToArray(_usePageTranslations, 2),
      switcherData = _usePageTranslations2[0],
      onChangeLocale = _usePageTranslations2[1].onChangeLocale;

  var _useWindowSize = useWindowSize(),
      width = _useWindowSize.width;

  var _useLocalization = useLocalization(),
      currentLocale = _useLocalization.currentLocale;

  var isRUlocale = currentLocale == 'ru' ? true : false;
  var isMobileScreen = width <= _theme.breakpoints.v2Tablet;
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: function theme(defaultTheme) {
      return _objectSpread(_objectSpread({}, defaultTheme), _theme);
    },
    children: /*#__PURE__*/_jsx(FooterComponent, {
      "data-place": "footer",
      children: /*#__PURE__*/_jsxs(FooterContainer, {
        children: [!isMobileScreen && /*#__PURE__*/_jsx("nav", {
          "aria-label": label,
          "data-track-place": "Footer",
          children: /*#__PURE__*/_jsx(FooterList, {
            children: categories.map(function (category, categoryIndex) {
              return /*#__PURE__*/_jsxs(FooterListItem, {
                children: [/*#__PURE__*/_jsx(FooterListTitleWrapper, {
                  children: /*#__PURE__*/_jsx(FooterListTitle, {
                    children: category.title
                  })
                }), /*#__PURE__*/_jsx(FooterInnerWrapper, {
                  children: /*#__PURE__*/_jsx("ul", {
                    children: category.groups.map(function (subcategory, subcategoryIndex) {
                      return /*#__PURE__*/_jsxs(FooterInnerItem, {
                        children: [/*#__PURE__*/_jsx("ul", {
                          children: subcategory.items.map(function (link, linkIndex) {
                            return /*#__PURE__*/_jsx(FooterInnerItem, {
                              children: /*#__PURE__*/_jsx(FooterInnerLink, {
                                href: link.path,
                                $size: "medium",
                                children: link.title
                              })
                            }, linkIndex);
                          })
                        }), subcategory.viewAllLink && !isRUlocale && /*#__PURE__*/_jsx(FooterAdditionalLink, {
                          href: subcategory.viewAllLink.path,
                          $variant: "regular",
                          $size: "medium",
                          withArrow: true,
                          children: subcategory.viewAllLink.title
                        })]
                      }, subcategoryIndex);
                    })
                  })
                })]
              }, categoryIndex);
            })
          })
        }), isMobileScreen && /*#__PURE__*/_jsx(AccordionMenu, {
          categories: categories
        }), /*#__PURE__*/_jsx(FooterBottomContainer, {
          children: /*#__PURE__*/_jsxs(FooterRow, {
            children: [/*#__PURE__*/_jsx(FooterCol, {
              children: /*#__PURE__*/_jsxs(FooterInnerRow, {
                children: [/*#__PURE__*/_jsx(FooterInnerCol, {
                  children: /*#__PURE__*/_jsx(FooterSocial, {
                    items: socialMedia
                  })
                }), /*#__PURE__*/_jsx(FooterInnerCol, {
                  children: /*#__PURE__*/_jsxs(FooterInnerColWrapper, {
                    children: [/*#__PURE__*/_jsx(LanguageSwitcherContainer, {
                      children: switcherData && /*#__PURE__*/_jsx(LanguageSwitcher, _objectSpread(_objectSpread({}, switcherData), {}, {
                        onSelect: function onSelect(e, link) {
                          onChangeLocale(link.locale);
                        },
                        color: "white",
                        position: "top"
                      }))
                    }), /*#__PURE__*/_jsx(FooterLinks, {
                      links: bottomLinks
                    })]
                  })
                })]
              })
            }), /*#__PURE__*/_jsx(FooterCol, {
              children: /*#__PURE__*/_jsx(FooterIcons, {})
            })]
          })
        })]
      })
    })
  });
};

export default Footer;